let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ctTmP")).then(() => parcelRequire('eIIrM'));